import { render, staticRenderFns } from "./NftPagination.vue?vue&type=template&id=51fcfc62&"
import script from "./NftPagination.vue?vue&type=script&lang=js&"
export * from "./NftPagination.vue?vue&type=script&lang=js&"
import style0 from "./NftPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports